import Phaser from 'phaser';
import VoteManager from '../services/VoteManager.js';
import BattleStateManager from '../game/BattleStateManager.js';

export class PredictionResultsScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PredictionResultsScene' });
  }
  
  async create(data) {
    const { width, height } = this.cameras.main;

    this.rewardsScript = data?.rewardsScript || BattleStateManager.getRewardsScript() || null;
    this.predictionResults = data?.predictionResults || null;
    const autoTransitionDelay = data?.autoTransitionDelay ?? 10000;
    const rewardsData = { rewardsScript: this.rewardsScript };
    
    // Background
    this.add.rectangle(width / 2, height / 2, width, height, 0x1F2937);
    
    // Title
    this.add.text(width / 2, 50, 'Prediction Results', {
      fontSize: '48px',
      fontStyle: 'bold',
      color: '#F3F300',
      stroke: '#000000',
      strokeThickness: 4
    }).setOrigin(0.5);
    
    // Fetch results if not provided
    let results = this.predictionResults;
    if (!results) {
      try {
        results = await VoteManager.getResults();
      } catch (error) {
        console.error('Error fetching prediction results:', error);
      }
    }

    if (results && results.results) {
      this.displayResults(results.results, width, height);
    } else {
      this.add.text(width / 2, height / 2, 'No prediction results available', {
        fontSize: '24px',
        color: '#EF4444'
      }).setOrigin(0.5);
    }

    if (results && results.userResults) {
      this.displayUserResults(results.userResults, width, height);
    }

    // Auto-transition
    this.time.delayedCall(autoTransitionDelay, () => {
      this.scene.start('RewardsScene', rewardsData);
    });
    
    // Skip button
    const skipButton = this.add.text(width - 50, height - 30, 'Skip >', {
      fontSize: '18px',
      color: '#9CA3AF'
    }).setOrigin(1, 1);
    skipButton.setInteractive({ useHandCursor: true });
    skipButton.on('pointerdown', () => {
      this.scene.start('RewardsScene', rewardsData);
    });
  }
  
  displayResults(results, width, height) {
    const startY = 150;
    const rowHeight = 40;
    
    // Table header
    this.add.text(width / 2 - 300, startY, 'Player', {fontSize: '20px', color: '#F3F4F6', fontStyle: 'bold'});
    this.add.text(width / 2 - 100, startY, 'Votes %', {fontSize: '20px', color: '#F3F4F6', fontStyle: 'bold'});
    this.add.text(width / 2 + 50, startY, 'Position', {fontSize: '20px', color: '#F3F4F6', fontStyle: 'bold'});
    this.add.text(width / 2 + 200, startY, 'Total Votes', {fontSize: '20px', color: '#F3F4F6', fontStyle: 'bold'});
    
    // Table rows
    results.forEach((result, index) => {
      const y = startY + (index + 1) * rowHeight + 20;
      
      this.add.text(width / 2 - 300, y, result.displayData?.name || result.optionKey, {
        fontSize: '16px',
        color: '#D1D5DB'
      });
      
      this.add.text(width / 2 - 100, y, `${result.votePercentage?.toFixed(1)}%`, {
        fontSize: '16px',
        color: '#10B981'
      });
      
      this.add.text(width / 2 + 50, y, `#${result.actualPosition}`, {
        fontSize: '16px',
        color: '#F3F300'
      });
      
      this.add.text(width / 2 + 200, y, result.totalVotesAmount?.toFixed(0) || '0', {
        fontSize: '16px',
        color: '#9CA3AF'
      });
    });
  }
  
  displayUserResults(userResults, width, height) {
    // Display user's specific results if they voted
    // ... implement user results display
  }
}
